export const KEY_CODES = {
    'ENTER': 13,
    'TAB': 9,
    'ESC': 27,
    'SHIFT':16,
    'ALT': 18,
    'CAPS_LOCK':20,
    'CTRL':17
};
export const UPDATE_URL = document.getElementById('hdnupdateurl') ? document.getElementById('hdnupdateurl').value : "";
const _bifrostUrl = (process.env.bifrost_url || '').replace(/\/+$/, '');
export const BIFROST_HTTP_URL = _bifrostUrl;
export const BIFROST_WS_URL = _bifrostUrl
    ? _bifrostUrl.replace(/^http(s?):\/\//, 'ws$1://')
    : '';
export const SERVER_SIDE_DATE_FORMAT = document.getElementById('cuDynamicDatePattern')? document.getElementById('cuDynamicDatePattern').value.toUpperCase():null;
export const DEFAULT_DATE_FORMAT =  SERVER_SIDE_DATE_FORMAT || 'MM/DD/YYYY';
export const DEFAULT_TIME_FORMAT  = DEFAULT_DATE_FORMAT +', hh:mm A';
export const DEFAULT_TIME_AT_FORMAT  = DEFAULT_DATE_FORMAT + ' [at] h:mm A z';
export const ListingViewConstants = {
    CardView:"Card View",
    ListView:"List View",
    Workkard:"WORKKARD",
    Activity:"ACTIVITY"
};
export const VALIDATE_SPECIAL_CHAR_FIELD_ARRAY =["adjuster name", "adjuster license number", "pa/oc name" , "pa/oc license or bar #" , "pa/oc firm name"];
export const SPECIAL_CHAR_VALIDATION_MSG ="Only letters, numbers, double quotes, and special characters including ~`@#$%*)(_{}:;/[]',&.- are allowed.";
export const ALPHA_NUMERIC_VALIDATION_MSG ="You can use lower-case letters (a-z), upper-case letters (A-Z) and digits (0-9).";
export const LICENSE_NUMERIC_VALIDATION_MSG ="Only letters, numbers, spaces, parentheses ( ), and the ampersand (&) are allowed.";
export const NO_ACTIVITY_MESSAGE ={
    "open": "Currently there are no open Activities which you are a part of.",
    "close": "Currently there are no closed Activities which you are a part of.",
    "unassigned": "Currently there are no unassigned Activities.",
    "watching": "Currently there are no Activities which you are following."
}
export const NO_WORKKARD_MESSAGE = {
    "open": "Currently there are no open Workkards which you are a part of.",
    "close": "Currently there are no closed Workkards which you are a part of.",
    "unassigned": "Currently there are no unassigned Workkards.",
    "watching": "Currently there are no Workkards which you are following."
}
export const TEMPLATE_VALUES = {
    "New Assignment - Peer Review": "New Assignment - Peer Review",
    "FA Status": "FA Status",
    "EMS Status": "EMS Status",
    "New Assignment - EMS Vendor Assignment":"New Assignment - EMS Vendor Assignment",
    "New Assignment - Vendor Specialist":"New Assignment - Vendor Specialist",
    "New Assignment - Engineer":"New Assignment - Engineer",
    "New Assignment - Comparative Estimate":"New Assignment - Comparative Estimate",
    "Field Adjuster - Final Report":"Field Adjuster - Final Report",
    "Field Adjuster - Reinspection Report":"Field Adjuster - Reinspection Report"
};
export const NO_DATA_FOUND = "No matching results found."
export const TitlePrefix = 'ClaimColony - '

export const publicApiConst = {
    oapi: 'oapi',
    auth: 'auth',
    api_file_upload: '/1.0/upload_file',
    api_file_upload_v2: '/2.0/upload_file'
};

export const PAGE_SIZE = 100;

export const partyPhoneTypes = [
    {"phone_type":"Please Select","id":"0"},
    {"phone_type":"Home","id":"1"},
    {"phone_type":"Fax","id":"2"},
    {"phone_type":"Cell","id":"3"},
    {"phone_type":"Work","id":"4"}
]

export const partySourceList = [
    {"text":"HARMONY","id":"HARMONY"},
    {"text":"SAMS-FL","id":"SAMS-FL"},
    {"text":"SAMS-NATIONAL","id":"SAMS-NATIONAL"}
]

export const partyStatesData = [
    {"Value": "AK", "DisplayName": "AK (Alaska)"},
    {"Value": "NJ", "DisplayName": "NJ (New Jersey)" },
    {"Value": "VT", "DisplayName": "VT (Vermont)"},
    {"Value": "MT", "DisplayName": "MT (Montana)"}
]

export const countriesData = [
    {"name":"Please Select","code":"","aliases":null},
    {"name":"Alaska","code":"AK","aliases":["Afghanistan","AFG","004","AF"]},
    {"name":"United States","code":"US","aliases":["Åland Islands","ALA","248","AX"]},
    {"name":"Albania","code":"AL","aliases":["Albania","ALB","008","AL"]},
    {"name":"Algeria","code":"DZ","aliases":["Algeria","DZA","012","DZ"]},
    {"name":"American Samoa","code":"AS","aliases":["American Samoa","ASM","016","AS"]},
    {"name":"Andorra","code":"AD","aliases":["Andorra","AND","020","AD"]}
]

export const associatedWorkkardMapping = {
  wk_id: "WkId",
  wk_number: "WkNumber",
  wk_status: "WkStatus",
  organization_name: "OrganizationName",
  sponsor_id: "SponsorId",
  sponsor_name: "SponsorName",
  is_sponsor_active: "IsSponsorActive",
  profile_image_url: "ProfileImageURL",
  dynamic_fields: "DynamicFields",
  org_id: "OrgId",
  assignee_org_id: "AssigneeOrgId",
  is_viewable: "IsViewable",
  is_workkard_clickable: "IsWorkkardClickable",
  template_type: "TemplateType",
  field_key: "FieldKey",
  field_value: "FieldValue"
};

export const DEFAULT_PRIORITY = 'ALLP';
